var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nonewrap"},[_c('div',{staticClass:"noneHint"},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.hint))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }